import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import YouTubePlayer from "react-youtube";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { abbreviateNumber } from "../../../utilities";
import Loader from "../../../Shared/Loader";
import { identifyUrl } from "../../Video/video_actions";
import TikTokPlayer from "../../../Shared/TikTokPlayer";
import "./SentimentReport.scss";
import InstagramEmbedd from "../../Video/Components/InstagramEmbed";
import { X } from "react-feather";

const mimeTypes = {
  ogm: "video/ogg",
  ogv: "video/ogg",
  ogg: "video/ogg",
  mp4: "video/mp4",
  webm: "video/webm",
};

export default ({ open, handleClose, videoDetail, videoProducts, start }) => {
  const [poster, setPoster] = useState(true);
  const { status: productsStatus, body: products } = videoProducts || {};
  const { status: videoStatus, body: video } = videoDetail || {};

  const renderProducts = () =>
    productsStatus === "success"
      ? products &&
        products.length > 0 &&
        products.map(({ id, name }, index) => (
          <Link
            to={`/products/${id}`}
            target="_blank"
            rel="noopener noreferrer"
            key={index}
          >
            {name}
            {index < products.length - 1 && ", "}
          </Link>
        ))
      : "Loading...";

  const urlUpdate = {
    "www.dropbox.com": "dl.dropboxusercontent.com",
    "dl=0": "raw=1#t=3",
  };

  const handleUrl = (url) => {
    identifyUrl(url)
      .then((response) => {
        if (response) {
          setPoster(true);
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          setPoster(false);
        }
      });
  };

  return (
    <Modal
      size="lg"
      style={{ maxWidth: "588px" }}
      isOpen={open}
      toggle={() => handleClose(!open)}
      className="modal-dialog-centered"
    >
      <ModalHeader
        className="justify-content-end"
        style={{padding:"15px 13px 10px 13px"}}
      >
        <X
          size={30}
          role="button"
          strokeWidth="1"
          onClick={() => handleClose(!open)}
        />
      </ModalHeader>
      {videoStatus === "success" ? (
        <ModalBody>
          {video?.video_url && video?.platform === "Instagram" && (
            <>
              <div className="d-flex justify-content-center">
                <InstagramEmbedd
                  url={video?.video_url}
                  linkText="Loading..."
                  height={564}
                  width={428}
                />
              </div>
            </>
          )}
          {video?.platform === "GoogleDrive" && video?.video_url && (
            <>
              {video.video_url.includes("denali") ? (
                <div
                  className="videoWrapper"
                  style={{ minHeight: "378px", position: "relative" }}
                >
                  <video
                    id="video"
                    className="videoFrame"
                    width="100%"
                    height="auto"
                    style={{
                      background: "black",
                    }}
                    controls
                    autoPlay
                  >
                    <source
                      src={`${video.video_url}#t=${start}`}
                      type={mimeTypes[video.video_url?.split(".")?.pop()] || ""}
                    />
                    <p>
                      Sorry, your browser doesn&apos;t support embedded videos.
                    </p>
                  </video>
                </div>
              ) : (
                <div style={{ position: "relative" }}>
                  <iframe
                    src={`${video.video_url.replace(
                      "view",
                      "preview"
                    )}&t=${start}s`}
                    width="100%"
                    height="auto"
                    sandbox="allow-scripts allow-same-origin"
                    allow="autoPlay"
                    allowFullScreen={true}
                    id="video"
                  ></iframe>
                </div>
              )}
            </>
          )}

          {video?.video_url &&
            (video.platform === "Vyrill_AWS_S3" ||
              video.platform === "AWS_S3_Swirl") && (
              <div className="videoWrapper">
                <video
                  id="video"
                  className="videoFrame"
                  width="100%"
                  height="auto"
                  style={{
                    maxHeight: "378px",
                    objectFit: "contain",
                    background: "black",
                  }}
                  autoPlay
                  controls={poster ? true : ""}
                  poster={
                    poster
                      ? undefined
                      : require("@src/assets/images/vyrill/videos/dropbox-deleted.png")
                          .default
                  }
                >
                  <source
                    src={video?.video_url + (start ? `#t=${start}` : "")}
                    type={mimeTypes[video?.video_url.split(".").pop()] || ""}
                  />
                </video>
              </div>
            )}
          {video.video_embedded_url && video.platform === "Youtube" && (
            <YouTubePlayer
              videoId={
                video.video_embedded_url &&
                video.video_embedded_url.match(/embed\/(.*)/)[1]
              }
              opts={{
                height: "310",
                width: "550",
                playerVars: {
                  autoplay: 1,
                  start,
                },
              }}
            />
          )}

          {video.video_url && video.platform === "Dropbox" && (
            <div className="videoWrapper">
              {handleUrl(
                video.video_url.replace(
                  /\b(?:www.dropbox.com|dl=0)\b/gi,
                  (matched) => urlUpdate[matched]
                )
              )}
              <video
                id="video"
                className="videoFrame"
                width="100%"
                height="auto"
                autoPlay
                controls={poster ? true : ""}
                poster={
                  poster
                    ? undefined
                    : require("@src/assets/images/vyrill/videos/dropbox-deleted.png")
                        .default
                }
              >
                <source
                  src={
                    video.video_url.replace(
                      "www.dropbox.com",
                      "dl.dropboxusercontent.com"
                    ) + `#t=${start}`
                  }
                  type={mimeTypes[video.title.split(".").pop()] || ""}
                />
                <p>Sorry, your browser doesn't support embedded videos.</p>
              </video>
            </div>
          )}

          {video.video_url && video.platform === "Tiktok" && (
            <TikTokPlayer video={video} />
          )}

          <br />
          <p className="VideoDialog-Detail">
            <b>Title:</b>{" "}
            <Link
              to={`/report/videos/${video._id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {video.title}
            </Link>
          </p>

          <p className="VideoDialog-Detail">
            <b>Creator:</b>{" "}
            <Link
              to={`/influencers/${video.video_author_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {video.author}
            </Link>
          </p>

          <p className="VideoDialog-Detail">
            <b>Product(s):</b> {renderProducts()}
          </p>

          <div className="VideoDialog-Quantified">
            <h6 className="VideoDialog-Quantity">
              <i className="fa-regular fa-eye" />
              <b> Views:</b>{" "}
              {video.youtube_view_count ||
                (video.view_count &&
                  abbreviateNumber(
                    video.youtube_view_count || video.view_count
                  ))}
            </h6>
            <h6 className="VideoDialog-Quantity">
              <i className="fa-regular fa-message" />
              <b> Comments:</b>{" "}
              {video.comment_count && abbreviateNumber(video.comment_count)}
            </h6>
            <h6 className="VideoDialog-Quantity">
              <i className="fa-regular fa-thumbs-up" />
              <b> Likes:</b> {video.likes && abbreviateNumber(video.likes)}
            </h6>
            {video.platform !== "Tiktok" && (
              <h6 className="VideoDialog-Quantity">
                <i className="fa-regular fa-thumbs-down" />
                <b> Dislikes:</b>{" "}
                {video.youtube_dislike_count &&
                  abbreviateNumber(video.youtube_dislike_count)}
              </h6>
            )}
          </div>
        </ModalBody>
      ) : (
        <div className="VideoDialog-Loader">
          <Loader />
        </div>
      )}
    </Modal>
  );
};
